export const AGE_MIN = 18;
export const AGE_MAX = 59;

export const DATE_IN_PAST_ERROR = 'Must be a date in the past';
export const IS_DOB_VALID_ERROR = `Sorry, comprehensive long-term disability insurance is generally only available to applicants aged ${AGE_MIN} to ${AGE_MAX} years old`;
export const IS_PRESENT_ERROR = 'This field is required';
export const PHONE_ERROR = 'Must be a valid phone number';
